import {
  type AcceptState,
  type AcceptStateDeliveryNote,
} from '~/modules/delivery-notes/list/constants';

/**
 * Calculates the accept state of a delivery note based on the line items.
 * @param lineItemAcceptStates - The accepts states of the line items.
 * @returns The accept state of the delivery note.
 */
export const getCalculatedAcceptState = (
  lineItemAcceptStates: AcceptState[],
): AcceptStateDeliveryNote | undefined => {
  if (!lineItemAcceptStates?.length) {
    return undefined;
  }

  const isFullyAccepted = lineItemAcceptStates?.every(
    (lineItemAcceptState) => lineItemAcceptState === 'accepted',
  );

  if (isFullyAccepted) {
    return 'accepted';
  }

  const isRejected = lineItemAcceptStates?.every(
    (lineItemAcceptState) => lineItemAcceptState === 'rejected',
  );

  if (isRejected) {
    return 'rejected';
  }

  const isPartiallyAccepted = lineItemAcceptStates?.some(
    (lineItemAcceptState) =>
      ['partiallyAccepted', 'accepted'].includes(lineItemAcceptState),
  );

  if (isPartiallyAccepted) {
    return 'partiallyAccepted';
  }

  return 'open';
};
